import { useEffect, useState } from "react";
import { FieldError } from "react-hook-form";

type Props = {
  className?: string;
  inputClassName?: string;
  labelClassName?: string;
  label?: string;
  placeholder?: string;
  name?: string;
  id?: string;
  value?: string
  defaultValue?: string;
  register?: Function;
  validation?: object;
  error?: any;
  errorText?: string;
  onChange?: Function;
  options: Array<Option>;
  disabled?: boolean;
};

type Option = {
  code: string;
  name: string;
};

const Radio = ({
  className = "",
  inputClassName = "",
  labelClassName = "",
  label = "",
  placeholder = "",
  id = "",
  name = "",
  defaultValue = "",
  value = "",
  register = () => { },
  onChange = () => { },
  validation,
  error,
  errorText = "Please enter a value",
  options,
  disabled = false,
}: Props) => {
  const [selected, setSelected] = useState<string>(defaultValue);
  useEffect(() => {
    if (defaultValue) {
      onChange(defaultValue)
    }
  }, [defaultValue])
  return (
    <div
      className={`grid grid-cols-1 mb-4 relative ${className ? className : ""}`}
    >
      {label && (
        <label className={`text-xs text-[var(--text-muted)] mb-1 ${labelClassName}`}>
          {label}
        </label>
      )}
      <div className="grid grid-cols-2 gap-4">
        {options.map((option) => {
          return (
            <label
              htmlFor={option.code}
              onClick={() => {
                if (disabled) return;
                setSelected(option.code);
                onChange(option.code);
              }}
              className={disabled ? "cursor-not-allowed opacity-70" : "cursor-pointer"}
              key={option.code}
            >
              <input
                {...register(name, validation)}
                type="radio"
                name={name}
                value={option.code}
                id={option.code}
                className="hidden"
                disabled={disabled}
              // defaultValue={defaultValue}
              />
              <span
                className={`flex h-12 items-center rounded-lg border bg-[var(--bg-surface)] px-4 text-base shadow-sm transition-colors ${selected === option.code || value === option.code
                    ? "border-[var(--color-primary)] text-[var(--text-main)]"
                    : "border-[var(--border-light)] text-[var(--text-muted)]"
                  } ${inputClassName}`}
              >
                <span>
                  <img
                    src={`/assets/icons/radio${selected === option.code || value === option.code
                        ? "_active"
                        : ""
                      }.svg`}
                    alt="radio"
                    className="inline h-7 w-7 me-3"
                  />
                </span>
                {option.name}
              </span>
            </label>
          );
        })}
      </div>
      {/* <input
      className={`bg-transparent rounded-md text-sm py-3.5 px-3 ${inputClassName} ${
        iconUrl ? "ps-10" : ""
      } ${error ? "border border-danger" : ""}`}
      type="radio"
      id={id}
      name={name}
      placeholder={placeholder}
      defaultValue={defaultValue}
      {...register(name, validation)}
      onChange={onChange}
    ></input> */}
      {/* {error && <p className="mt-1 text-xs text-danger">{errorText}</p>} */}
    </div>
  );
};

export default Radio;
